import { useClearMachineCommand } from "../hooks/useClearMachineCommand";

// #3518: mounts the Station Monitor clear poll. It renders NOTHING. A remote clear
// that was blocked by un-uploaded work is an admin problem, not something the scribe
// can act on, so it is reported to the server and shown in Station Monitor, never on
// the tablet (a scribe warning appears only if the scribe must act).
export default function ClearMachineCommandWatcher() {
  useClearMachineCommand();
  return null;
}
